import Handlebars from 'handlebars';

export interface CustomCodeTemplateParseError {
  message: string;
  lineNumber: number | null;
  column: number | null;
}

export function findCustomCodeTemplateParseError(code: string): CustomCodeTemplateParseError | null {
  try {
    Handlebars.precompile(code, { noEscape: false, strict: false });
    return null;
  } catch (thrownParseError) {
    const handlebarsException = thrownParseError as Error & { lineNumber?: number; column?: number };
    return {
      message: handlebarsException.message ?? String(thrownParseError),
      lineNumber: handlebarsException.lineNumber ?? null,
      column: handlebarsException.column ?? null,
    };
  }
}
